import ApiService from '@services/api.service'

export default {
    getSettings() {
        return ApiService.get('/system-settings');
    },
    updateSettings(data) {
        // Use FormData for file upload
        const formData = new FormData();
        if (data.system_name_ar) formData.append('system_name_ar', data.system_name_ar);
        if (data.system_name_en) formData.append('system_name_en', data.system_name_en);
        if (data.system_timezone) formData.append('system_timezone', data.system_timezone);
        if (data.system_currency) formData.append('system_currency', data.system_currency);
        if (data.default_language) formData.append('default_language', data.default_language);

        // Contact and address fields
        if (data.address) formData.append('address', data.address);
        if (data.phone) formData.append('phone', data.phone);
        if (data.email) formData.append('email', data.email);

        // Color settings
        if (data.primary_color) formData.append('primary_color', data.primary_color);
        if (data.secondary_color) formData.append('secondary_color', data.secondary_color);

        // Tax settings
        if (data.tax_number) formData.append('tax_number', data.tax_number);
        if (data.tax_rate !== undefined && data.tax_rate !== null) formData.append('tax_rate', data.tax_rate);

        if (data.system_logo && data.system_logo instanceof File) {
            formData.append('system_logo', data.system_logo);
        }

        if (data.system_favicon && data.system_favicon instanceof File) {
            formData.append('system_favicon', data.system_favicon);
        }

        // New Logos
        if (data.system_login_logo && data.system_login_logo instanceof File) {
            formData.append('system_login_logo', data.system_login_logo);
        }
        if (data.system_sidebar_logo && data.system_sidebar_logo instanceof File) {
            formData.append('system_sidebar_logo', data.system_sidebar_logo);
        }

        return ApiService.post('/system-settings/update', formData);
    },

    applyDemoPreset(preset) {
        return ApiService.post('/system-settings/apply-demo-preset', { preset });
    },

    runDemoStep(payload) {
        return ApiService.post('/system-settings/run-demo-step', payload);
    }
}
